export enum eToKhaiLogType {
    TAO_MOI = 1,
    CAP_NHAT = 5,
    CO_QUAN_THUE_PHAN_HOI = 2
}